<div class="splashscreen" *ngIf="show">
  <!-- Animated Background Gradient -->
  <div class="gradient-bg"></div>

  <!-- Floating Particles -->
  <div class="particle particle-1"></div>
  <div class="particle particle-2"></div>
  <div class="particle particle-3"></div>
  <div class="particle particle-4"></div>

  <div class="splashscreen-content">
    <!-- Logo mit futuristischen Animationen -->
    <div class="logo-container">
      <!-- Orbital Rings System -->
      <div class="orbit-ring-1"></div>
      <div class="orbit-ring-2"></div>
      <div class="orbit-ring-3"></div>

      <!-- Main Logo -->
      <img
        src="assets/img/logo-no-name.svg"
        alt="FixPlaner"
        class="logo-icon"
      />
    </div>

    <!-- App Name als SVG Logo (mit Dark Mode Support) -->
    <div class="app-name-logo">
      <!-- Light Mode Logo -->
      <img
        src="assets/img/logo-text.svg"
        alt="FixPlaner"
        class="logo-text logo-text-light"
      />
      <!-- Dark Mode Logo -->
      <img
        src="assets/img/logo-text-dark.svg"
        alt="FixPlaner"
        class="logo-text logo-text-dark"
      />
    </div>

    <!-- Animated Loading Dots -->
    <div class="loading-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</div>
